
const locations = () => {
	return new Promise((resolve, reject) => {
		axios('/api/locations').then(res => {
			resolve(res.data)
		}, res => {
			reject()
		})
	})
}

const location = () => {
	return new Promise((resolve, reject) => {
		axios('/api/location/show').then(res => {
			resolve(res.data)
		}, res => {
			reject()
		})
	})
}

const countries = () => {
	return new Promise((resolve, reject) => {
		axios('/api/location/countries').then(res => {
			resolve(res.data)
		}, res => {
			reject()
		})
	})
}

const locationBy = slug => {
	return new Promise((resolve, reject) => {
		axios('/api/location/show/' + slug).then(res => {
			resolve(res.data)
		}, res => {
			reject()
		})
	})
}

const locationSearchCity = query => {
	return new Promise((resolve, reject) => {
		axios('/api/location/search-city?query=' + query).then(res => {
			resolve(res.data)
		}, res => {
			reject()
		})
	})
}

const locationByName = (query, exclude) => {
	return new Promise((resolve, reject) => {
		const excludeStr = exclude ? '&exclude=' + exclude.join(',') : ''
		axios('/api/location/search?query=' + query + excludeStr).then(res => {
			resolve(res.data)
		}, res => {
			reject()
		})
	})
}

const breadcrumbsBy = (location, additional) => {
    var breadcrumbs = []
    
    while (location) {
        breadcrumbs.push({title: location.name, url: location.url, external: true})
        location = location.location
    }
    breadcrumbs = breadcrumbs.reverse()
    if(typeof(additional) == 'string'){
		breadcrumbs.push({title: additional})
    }else{
    	for(var i = 0; i < additional.length; i ++){
    		breadcrumbs.push(additional[i])
    	}
    }
	return breadcrumbs
}


export {
	locations,
	location,
	breadcrumbsBy,
	locationBy,
	locationSearchCity,
	locationByName,
	countries
}